import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ClipboardModule,
        MatToolbarModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTabsModule,
        MatSortModule,
        MatTableModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDividerModule,
        MatMenuModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatDividerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
    ],
    exports: [
        ClipboardModule,
        MatToolbarModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTabsModule,
        MatSortModule,
        MatTableModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDividerModule,
        MatMenuModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatDividerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
    ],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'it-IT' }],
})
export class MaterialModule {}
